import { Box, Flex } from 'components/elements'
import { Modal } from 'components/modal'
import { ModalForm } from 'features/profile/components/EditProfileForm'

interface QuoteReviewModalProps {
  openModal: boolean
  setOpenModal: (open: boolean) => void
  handleAccept: () => void
  background?: string
  isLoading?: boolean
  variant?: 'light' | 'dark'
}

const QuoteReviewModal = ({ openModal, setOpenModal, handleAccept, background, isLoading, variant = 'dark' }: QuoteReviewModalProps) => {
  const isLight = variant === 'light'
  const modalStyle = isLight ? { maxWidth: '800px', background: '#ffffff', backdropFilter: 'none' } : { maxWidth: '800px', ...(background ? { background } : {}) }
  const titleColor = isLight ? '$black39' : background ? '$yellow2' : '$primary'
  const headingCss = { color: isLight ? '$black39' : '$white', fontWeight: '$semibold', mb: '$2' }
  const bodyCss = { color: isLight ? '$black00' : '$white', lineHeight: 1.6, mb: '$3' }

  return (
    <Modal
      isLoading={isLoading}
      active={openModal}
      hideModal={() => setOpenModal(false)}
      onAccept={handleAccept}
      title=""
      description=""
      style={modalStyle}
      variant={variant}
      children={
        <>
          <ModalForm onSubmit={handleAccept} css={{ gap: 10 }}>
            <Flex direction={'column'} wrap={'wrap'}>
              <Box as="h2" css={{ fontWeight: '$semibold', color: titleColor, mb: '$2' }}>
                Terms and Conditions
              </Box>
              <Box as="h4" css={headingCss}>
                Your Agreement
              </Box>
            </Flex>
            <Flex direction={'column'} wrap={'wrap'}>
              <Box as="p" css={bodyCss}>
                Last Revised: December 16, 2022
              </Box>
              <Box as="p" css={bodyCss}>
                Welcome to DLT Alert. This site is provided as a service to our visitors and may be used for informational purposes only. Because the Terms and Conditions contain
                legal obligations, please read them carefully.
              </Box>
              <Box as="h3" css={headingCss}>
                1. YOUR AGREEMENT
              </Box>
              <Box as="p" css={bodyCss}>
                By using this Site, you agree to be bound by, and to comply with, these Terms and Conditions. If you do not agree to these Terms and Conditions, please do not use
                this site. PLEASE NOTE: We reserve the right, at our sole discretion, to change, modify or otherwise alter these Terms and Conditions at any time. Unless otherwise
                indicated, amendments will become effective immediately. Please review these Terms and Conditions periodically. Your continued use of the Site following the posting
                of changes and/or modifications will constitute your acceptance of the revised Terms and Conditions and the reasonableness of these standards for notice of changes.
                For your information, this page was last updated as of the date at the top of these terms and conditions.
              </Box>
              <Box as="h3" css={headingCss}>
                2. PRIVACY
              </Box>
              <Box as="p" css={{ ...bodyCss, mb: 0 }}>
                Please review our Privacy Policy, which also governs your visit to this Site, to understand our practices.
              </Box>
            </Flex>
          </ModalForm>
        </>
      }
      isForm={true}
      acceptText={'Accept'}
    />
  )
}

export default QuoteReviewModal
